import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navigation from './components/layout/Navigation';
import Today from './pages/Today';
import History from './pages/History';
import Settings from './pages/Settings';
import About from './pages/About';
import Tooltip from './components/common/Tooltip';
import { AlbumProvider, useAlbum } from './contexts/AlbumContext';

import { Analytics } from "@vercel/analytics/react"

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { hasProject } = useAlbum();
  
  if (!hasProject) {
    // Show the content but with appropriate UI handling for no project
    return children;
  }
  
  return children;
};

const App = () => {
  const location = useLocation();
  const isToday = location.pathname === '/today';

  return (
    <AlbumProvider>
      <Tooltip>
        <div className={`flex flex-col w-full max-w-full h-screen overflow-x-hidden pangram-sans-medium selection:text-amber-50 selection:bg-neutral-500 ${isToday ? 'md:h-screen' : ''}`}>
          <Navigation />
          <Routes>
            <Route path="/" element={<Navigate to="/today" />} />
            <Route 
              path="/today" 
              element={
                <ProtectedRoute>
                  <Today />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/history" 
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              } 
            />
            <Route path="/settings" element={<Settings />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>
      </Tooltip>
      <Analytics />
    </AlbumProvider>
  );
};

export default App;